// extracted by mini-css-extract-plugin
export default {"dlContainer":"styles_dlContainer__QA0sD","dropzoneText":"styles_dropzoneText__fZLMC","dropzoneSubText":"styles_dropzoneSubText__iV-Ok"};